__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@jsq/flags-react", "1.14.2", () => (Promise.all([__webpack_require__.e(4644), __webpack_require__.e(1118), __webpack_require__.e(3197), __webpack_require__.e(2346), __webpack_require__.e(4526)]).then(() => (() => (__webpack_require__(84526))))));
			register("@jsq/observability", "1.13.0", () => (() => (__webpack_require__(8391))), 1);
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(40961))), 1);
			register("react-responsive", "8.2.0", () => (Promise.all([__webpack_require__.e(7300), __webpack_require__.e(7988)]).then(() => (() => (__webpack_require__(17988))))));
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(54625))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(96540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};